import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { StyledDiv } from '../../../../Theme/CommonStyled';

export const StyledNavbarContainer = styled(StyledDiv)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 95px;
  z-index: ${({ theme }): number => theme.zIndices[4]};
  border-top: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.border};
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  direction: rtl;
`;

export const StyledLink = styled(Link)<{ isActive: boolean }>`
  text-decoration: none;
  color: ${({ theme }): string => theme.colors.secondaryText};
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${({ theme }): string => theme.fontSizes[2]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};

  i {
    :before {
      color: ${({ theme, isActive }): string =>
        isActive ? theme.colors.primaryGreen : theme.colors.secondaryText};
    }
  }
`;
